<script>
import { push } from 'svelte-spa-router'
import { fly } from 'svelte/transition'

import { nightmode, count, check } from "./stores5.js"

const night_toggle = () => {
  $count++
  if ($count % 2 === 0){
  nightmode.set(false)
  $check = ""
  } else {
  nightmode.set(true)
  $check = "checked"
  }
}
</script>

<nav>
    <div style="position:absolute; top:40px; left:0px; border-radius:0 0px 10px 10px; padding:0 10px 30px 10px; z-index:10" transition:fly="{{x: -300}}">
        <div class="switch-border"></div>
        <input type="checkbox" class="text" data-text-on="|" on:click={night_toggle} checked={$check}>
    </div>
    <ul class="menu" class:night-menu={$nightmode} id="menu" transition:fly="{{x: -300}}">
        <li class="menu-list-space1"></li>
        <li class="menu-list-top1" on:click={() => push('/base1')}>第75回記念祭</li>
        <li class="menu-list-space2"></li>
        <li class="margin"></li>
        <li class="menu-list" on:click={() => push('/base2')}>開催概要</li>
        <li class="menu-list" on:click={() => push('/base3')}>団体紹介/予約</li>
        <li class="menu-list" on:click={() => push('/base4')}>テーマ「共鳴」</li>
        <li class="menu-list" on:click={() => push('/base5')}>校内マップ</li>
        <li class="menu-list" on:click={() => push('/base6')}>アクセス</li>
        <li class="menu-list" on:click={() => push('/base7')}>問い合わせ</li>
        <li class="margin"></li>
    </ul>
</nav>

<style>
.menu{
    position:fixed;
    justify-content: space-between;
    top:0px;
    left:-100%;
    display:flex;
    flex-wrap: wrap;
    width:100%;
    height:100%;
    padding:0;
    margin:0;
    background-color: #ffffff;
    opacity:1;
    visibility: visible;
    -webkit-transform: translateX(100%);
    transform:translateX(100%);
    -webkit-transition:1.0s cubic-bezier(0,1,.26,1);
    transition:1.0s cubic-bezier(0,1,.26,1);
}
.night-menu{
    background-color: #222831;
    color:#dddddd;
}
.menu-list{
    list-style-type: none;
    font-size:24px;
    width:100%;
    margin:15px 0 15px 0;
    text-align: center;
    cursor: pointer;
}
.menu-list-space1{
    list-style-type: none;
    flex-basis:44%;
}
.menu-list-top1{
    list-style-type: none;
    font-size:24px;
    font-weight: 400;
    letter-spacing: 5px;
    text-align: right;
    flex-basis:50%;
    margin-top:16px;
    margin-bottom:20px;
    font-family: 'Noto Sans JP';
    line-height: 1em;
    cursor: pointer;
}
.menu-list-space2{
    list-style-type: none;
    flex-basis:6%;
}
.margin{
    width:100%;
    height: 100px;
}

.switch-border{
    position: relative;
    top:10px;
    left:13px;
    height:180px;
    width:2.5px;
    background-color: #000000;
}
input {
    display: inline-block;
    margin: 0 4px;
    cursor: pointer;
}
input[type="checkbox"] {
    -webkit-appearance: none;
    appearance: none;
    background-color: #ffffff;
    border-radius: 10px;
    border:0;
    height: 50px;
    width: 20px;
    transition:1.0s cubic-bezier(0,1,.26,1);
  }
input[type="checkbox"]:active {
    background-color: #222831;
    transition:1.0s cubic-bezier(0,1,.26,1);
}
  input[type="checkbox"]:checked {
    background-color: #222831;
    border:0;
}
input[type="checkbox"]::before {
    background-color: #222831;
    border-radius: 8.2px;
    content: "";
    display: inline-block;
    height: 16.4px;
    margin-left: 2px;
    margin-top: 4px;
    transition:1.0s cubic-bezier(0,1,.26,1);
    width: 16.4px;
}
input[type="checkbox"]:checked::before {
    background-color: #FCDAB7;
    margin-top: 28px;
    transition:1.0s cubic-bezier(0,1,.26,1);
    box-shadow: 0 0 0 1px #FB9300 inset, 0 0 0 1px #F54748, 0 0 0 7px #343F56;
}
input[type="checkbox"].text {
    position: relative;
}
input[type="checkbox"].text::after {
    content: attr(data-text-off);
    font-size: 30px;
    position: absolute;
    right: 2px;
    top: 2px;
}
input[type="checkbox"].text:checked::after {
    color: #ffffff;
    content: attr(data-text-on);
    left: 6.5px;
    top:-7.5px;
    right: auto;
    font-size:30px;
    color:#000000;
}
@media screen and (max-width:763px){
    input[type="checkbox"].text:checked::after {
      left:6.8px;
    }
}
</style>